import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { getOptionsQueryParams } from "@app/class/Utilities";
import { IVideoChannelMedia } from "@app/main/components/videos/models/IVideoChannelMedia";
import { IVideoEntry } from "@app/main/components/videos/models/IVideoEntry";
import { IVideoEventQueryOptions } from "@app/main/components/videos/models/IVideoEventQueryOptions";
import { IVideoQueryOptions } from "@app/main/components/videos/models/IVideoQueryOptions";
import { ConstantsService } from "@app/services/constantsService";
import { Observable, of } from "rxjs";
import { map } from "rxjs/operators";

@Injectable({
    providedIn: 'root'
})
export class FoundationVideoService {
    private apiUrl: string;
    constructor(
        private readonly http: HttpClient,
        private readonly constantsService: ConstantsService) {
        this.apiUrl = this.constantsService.getApiUrl();
    }

    getVideoEntries(options: IVideoEventQueryOptions = {}): Observable<IVideoEntry[]> {
        const params = getOptionsQueryParams(options);

        return this.http.get<IVideoEntry[]>(`/api/cameras/videoentries`, params).pipe(
            map(videos => {
                return this.setPrimaryChannel(videos);
            }));
    };

    getChannelMedia(options: IVideoQueryOptions): Observable<IVideoChannelMedia[]> {
        const params = getOptionsQueryParams(options);

        return this.http.get<IVideoChannelMedia[]>(`/api/cameras/channelmedia`, params);
    }

    //--

    private setPrimaryChannel(videos: IVideoEntry[]): IVideoEntry[] {
        videos.forEach(video => {
            video.channelMedia = [];

            if (!video.ThumbnailFileGuid && !video.Mp4VideoFileGuid) {
                return;
            }

            video.channelMedia.push({
                ChannelId: 0, // Aka primary
                thumbnailUrl: `${this.apiUrl}/api/cameras/media/${video.ThumbnailFileGuid}`,
                ThumbnailFileGuid: video.ThumbnailFileGuid,
                mp4VideoUrl: `${this.apiUrl}/api/cameras/media/${video.Mp4VideoFileGuid}`,
                Mp4VideoFileGuid: video.Mp4VideoFileGuid,
                mainChannel: true,
            })
        })

        return videos;
    }
}
